<template>
  <v-navigation-drawer
      app
      clipped
      right
      v-model="RIGHT_PROCESS_DRAWER_STATE"
      :mini-variant="isMini"
      permanent
      mini-variant-width="50"
      :class="{'drawer-mini': !RIGHT_PROCESS_DRAWER_STATE}"
      class="mt-15 pb-15 mt-md-16 pb-md-16"
      width="410"
  >
    <div v-show="!isMini">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs}">
          <v-btn class="pa-5" icon @click.stop="TOOGLE_RIGHT_PROCESS_DRAWER_STATE" v-bind="attrs" v-on="on">
            <v-icon color="primary">close</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('buttons:close-sidebar') }}</span>
      </v-tooltip>
    </div>
    <div v-show="isMini" class="text-center">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs}">
          <v-btn class="pa-5" icon @click.stop="TOOGLE_RIGHT_PROCESS_DRAWER_STATE" v-bind="attrs" v-on="on">
            <v-icon color="primary">link</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('buttons:open-sidebar') }}</span>
      </v-tooltip>
    </div>

    <v-divider></v-divider>

    <v-expansion-panels v-show="!isMini" tile accordion>
      <!-- Building expansion panel -->
      <v-expansion-panel v-if="isOperator || isAdmin">
        <v-expansion-panel-header>
          <v-row align="center">
            <v-col cols="1"><v-icon>apartment</v-icon></v-col>
            <v-col cols="5">
              <span class="red-dot"></span>
              <span class="ml-2">{{ $t('common:building_plural')}} ({{ this.totalBuildingCnt }})</span>
            </v-col>
            <v-col cols="6" class="text-right">
              <v-btn color="primary" rounded small elevation="0" :to="`/${$store.state.manager.bookModuleUrl}/buildings?openForm=true`">
                <v-icon>add</v-icon>
                {{ $t('buttons:add')}}
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-header>

        <v-expansion-panel-content eager>
          <v-list>
            <v-list-item v-for="item in restBuilding" :key="item.id" :to="`/${$store.state.manager.bookModuleUrl}/buildings/edit/${item.id}`">
              <span class="ml-2">{{ item.name }} - {{ item.objectNumber }}</span>
            </v-list-item>
          </v-list>
          <v-row justify="center">
            <v-btn @click="callBuildings" class="mr-3 mt-3 mb-2">                                    
              <v-icon large color="primary">insert_link</v-icon>{{$t('common:building_plural')}}
            </v-btn>
          </v-row>          
        </v-expansion-panel-content>

      </v-expansion-panel>

      <!-- Facility expansion panel -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row align="center">
            <v-col cols="1"><v-icon>account_tree</v-icon></v-col>
            <v-col cols="5">
              <span class="red-dot"></span>
              <span class="ml-2">{{ $t('common:facility_plural')}} ({{ this.totalFaciltiesCnt }})</span>
            </v-col>
            <v-col cols="6" class="text-right">
              <v-btn color="primary" rounded small elevation="0" :to="`/${$store.state.manager.bookModuleUrl}/facilities?openForm=true`">
                <v-icon>add</v-icon>
                {{ $t('buttons:add')}}
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-list>
            <v-list-item-group>
              <v-list-item v-for="item in restFacilities" :key="item.id" :to="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${item.id}`">
                <span class="ml-2">{{ item.name }} - {{ item.objectNumber }}</span>
              </v-list-item>
             
            </v-list-item-group>
          </v-list>
          <v-row justify="center">
            <v-btn @click="callFaclities" class="mr-3 mt-3 mb-2">
              <v-icon large color="primary">insert_link</v-icon>{{ $t('common:facility_plural')}}
            </v-btn>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-navigation-drawer>
</template>
<script>
import BuildingService from "@/modules/book/services/building-service";
import FacilityService from "@/modules/book/services/facility-service";
import Building from "@/modules/book/data/building";
import Facility from "@/modules/book/data/facility";
import DataUtils from "@/modules/core/services/data-utils";
import Utils from "@/modules/core/services/utils";

import {mapActions, mapState, mapGetters} from 'vuex'

export default {
  name: 'ProcessQuickLinkSidebar',
  data() {
    return {
      restFacilities: [],
      totalFaciltiesCnt: 0,
      restBuilding: [],
      totalBuildingCnt: 0
    }
  },
  computed: {
    ...mapState('book/layout', {
      rightProcessDrawer: state => state.rightProcessDrawer
    }),
    RIGHT_PROCESS_DRAWER_STATE : {
      get() {
        return this.rightProcessDrawer
      },
      set(newValue) {
        if (newValue === this.rightProcessDrawer) return;
        this.TOOGLE_RIGHT_PROCESS_DRAWER_STATE();
      }
    },
    isMini() {
      // if screen size is md or lower
      if(this.$vuetify.breakpoint.mdAndDown) {
        return this.RIGHT_PROCESS_DRAWER_STATE
      } else {
        return !this.RIGHT_PROCESS_DRAWER_STATE
      }
    },
    ...mapGetters('auth', ['isOperator', 'isAdmin']),
  },
  methods: {
    ...mapActions(
        'book/layout', ['TOOGLE_RIGHT_PROCESS_DRAWER_STATE']
    ),
    callBuildings() {
      this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/buildings`);
    },
    callFaclities() {
      this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/facilities`);
    }

  },
  created() {      

    let search = '';
    
    BuildingService.readAllPaginatedFromAPI(
      0/*options.page - 1*/,
      process.env.VUE_APP_MAX_SIZE_OF_ITEMS/*options.itemsPerPage*/,
      search,
      ["name"]/*sort*/,
      [false]/*sortAsc*/,
      (res) => {
       this.restBuilding = DataUtils.parseDataToObjectArray(res.data.content, Building);
       this.totalBuildingCnt = res.data.totalElements;
      },
      (error) => {
         this.$logger.error("Error at fetching all buildings: " + error);
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/facility:common.building-data')}))
      })    

    FacilityService.readAllPaginatedFromAPI(
      0/*options.page - 1*/,
      process.env.VUE_APP_MAX_SIZE_OF_ITEMS/*options.itemsPerPage*/,
      search,
      ["name"]/*sort*/,
      [false]/*sortAsc*/,
      (res) => {
       this.restFacilities = DataUtils.parseDataToObjectArray(res.data.content, Facility);
       this.totalFaciltiesCnt = res.data.totalElements;
      },
      (error) => {
         this.$logger.error("Error at fetching all facilities: " + error);
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/facility:facility.snackbar.facilities')}))
      })
  }
}
</script>
